import React, {useEffect, useState} from "react";

import {Plus as AddIcon, Settings as SettingsIcon} from "react-feather"
import styles from "./style.module.css"
import style from "./style.module.css"
import Dropzone from 'react-dropzone';
import {
    ArrowDownward as ArrowDown,
    ArrowUpward as ArrowUp,
    Delete as Remove,
    Delete as RemoveIcon
} from "@material-ui/icons";

import {
    BackButton,
    Button,
    Centered,
    CircularProgress,
    FlexRowSpaceBetween,
    FormControl,
    Paper,
    Space,
    TextField,
    Typography,
} from "../../../../common/components/libs";

import {observer} from "mobx-react";
import {useStores} from "../../../../hooks";
import {BadgeType, MediaItems, MediaType, MenuItem as MenuItemType} from "../../../../services/menu/models";
import {uploadFile} from "../../../../services/files";
import {
    Box,
    Checkbox,
    FormControlLabel,
    FormGroup,
    Hidden,
    InputAdornment,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableRow
} from "@material-ui/core";
import {useHistory, useParams} from "react-router-dom";

import {changeCheckboxEventHandlerDecorator, changeEventHandlerDecorator, localize,} from "../../../../common/libs";
import {FadeInOutVertical} from "../../../../common/components/Animated";
import EditModifiersSetInline from "../modifiersSet/components/EditModifiersSetInline";
import AddModifiersSetToMenuItemForm from "./components/AddModifiersSetToMenuItemForm";
import {SnackbarType} from "../../../../stores/common";
import ImageCropperForm, {ImageAspectRatio} from "../../../../common/components/ImageCropperForm";
import {Trans, useTranslation} from "react-i18next";
import useSearchExternalItems from "./hooks/useSearchExternalItems";
import MenuItemSchedule from "./components/MenuItemSchedule";
import {MenuFormType} from "../../store/menu/forms";
import DeleteMenuItemForm from "./components/DeleteMenuItemForm";
import LocalizedInput from "../../../../common/components/translation/LocalizedInput";
import CookingTimeSelect from "./components/CookingTimeSelect";
import {defaultMediaItems} from "./components/CreateMenuItemForm";


const EditMenuItemPage = () => {
    const {t, ready} = useTranslation(["general", "menu"], {useSuspense: false});
    const {menuStore, generalStore, constantsStore, modifiersSetsStore, translationStore} = useStores();

    const locale = generalStore.locale.id;
    const currencyId = generalStore.currency.id;

    const [externalId, setExternalId] = useState<string | undefined>();
    const [price, setPrice] = useState(0);
    const [priceToShow, setPriceToShow] = useState("");
    const [oldPrice, setOldPrice] = useState(0);
    const [oldPriceToShow, setOldPriceToShow] = useState("");
    const [sortOrder, setSortOrder] = useState(0);
    const [photos, setPhotos] = useState([]);
    const [isUploadInProgress, setIsUploadInProgress] = useState(false);
    const [currentFile, setCurrentFile] = useState<File | undefined>();
    const [category, setCategory] = useState<number | null>();
    const [isInStopList, setIsInStopList] = useState(false);
    const [arCodeLink, setArCodeLink] = useState(null)
    const [arCodeImage, setArCodeImage] = useState(null)
    const [supplierLogoUrl, setSupplierLogoUrl] = useState(null)

    const [newBadgeChecked, setNewBadgeChecked] = useState<boolean>(false);
    const [spicyBadgeChecked, setSpicyBadgeChecked] = useState<boolean>(false);
    const [verySpicyBadgeChecked, setVerySpicyBadgeChecked] = useState<boolean>(false);
    const [vegetarianBadgeChecked, setVegetarianBadgeChecked] = useState<boolean>(false);
    const [hitBadgeChecked, setHitBadgeChecked] = useState<boolean>(false);

    const [weight, setWeight] = useState<string | null>(null);
    const [measurement, setMeasurement] = useState<string | null>(null);
    const [calories, setCalories] = useState<number | null>( null);
    const [carbohydrates, setCarbohydrates] = useState<number | null>( null);
    const [fats, setFats] = useState<number | null>( null);
    const [proteins, setProteins] = useState<number | null>( null);

    const [cookingTimeFromCategory, setCookingTimeFromCategory] = useState<boolean>(false);
    const [individualCookingTime, setIndividualCookingTime] = useState<boolean>(false);

    const [media, setMedia] = useState<MediaItems[]>([]);
    const [fileName, setFileName] = useState<string>("");
    const [isMediaSubtypeUploadInProgress, setMediaSubtypeUploadInProgress] = useState(false)
    const [isImagePreviewCropperVisible, setIsImagePreviewCropperVisible] = useState(false);
    const [isImageRegularCropperVisible, setIsImageRegularCropperVisible] = useState(false);
    const [mediaType, setMediaType] = useState<MediaType>(MediaType.source);
    const [currentMediaIndex, setCurrentMediaIndex] = useState<number | null>(null)


    const [modifiersSets, setModifiersSets] = useState<{ menuItemModifierSetId: number, sortOrder: number }[]>([]);
    const history = useHistory();
    const params = useParams<{ menuId: string, categoryId: string, menuItemId: string }>();
    const menuId = parseInt(params.menuId);
    const menuItemId = parseInt(params.menuItemId);
    const categoryId = parseInt(params.categoryId);


    const [isAddModifersSetFormVisible, setIsAddModifersSetFormVisible] = useState(false);
    const currencyFormatter = constantsStore.getCurrencyFormatter(generalStore.currency.id);

    const [isScheduleOpen, setIsScheduleOpen] = useState<boolean>(false);

    const getRemoveModifiersSet = (index: number) => () => {
        const newModifiers = [...modifiersSets];
        newModifiers.splice(index, 1);
        setModifiersSets(newModifiers)
    };

    const [current, setCurrent] = useState<MenuItemType | undefined>();

    const externalItemsMethods = useSearchExternalItems(menuId);

    const hasIIkoIntegration = menuStore.hasIIkoIntegration();

    const measurementVariants: string[] = [ `${t("menu:kg")}`,`${t("menu:g")}`,`${t("menu:mg")}`,`${t("menu:l")}`,`${t("menu:ml")}`]


    const getFile = async (url: string) => {
        let file: File;
        let response = await fetch(url);
        const blob: Blob = await response.blob();
        file = new File([blob], "image.jpeg");
        setCurrentFile(file)
    }

    useEffect(() => {
        (async () => {
            await modifiersSetsStore.ensureLoaded();
            await menuStore.fetchMenuById(menuId);
        })();
    }, [menuId]);

    useEffect(() => {
        const menu = menuStore.currentMenu;
        if (!menu) return;
        const current = menuStore.getMenuItemByCategoryIdAndId(categoryId, menuItemId);
        if (!current) return;
        setCurrent(current);

        generalStore.setPageTitle(t("general:editing"));
        translationStore.setLangs(menu.menu.data.availableLanguages)
    }, [menuStore.currentMenu, generalStore, menuItemId, categoryId, menuStore, ready]);


    useEffect(() => {
        if (current) {
            setPrice(current.data.sellPrice.price);
            setPriceToShow(currencyFormatter.toShow(current.data.sellPrice.price, true));
            setOldPrice(current.data.oldPrice?.price || 0)
            setOldPriceToShow(currencyFormatter.toShow(current.data.oldPrice?.price || 0, true))
            setSortOrder(current.data.sortOrder);
            setPhotos(current.data.photosUrls);
            setMedia(current.data.media);
            setIsUploadInProgress(false);
            setCurrentFile(undefined);
            setModifiersSets(current.data.menuItemModifierSets);
            setCategory(categoryId);
            setIsInStopList(current.data.isInStopList);
            setExternalId(current.externalId)
            setIsScheduleOpen(current.data.workingSchedule.isEnabled);
            setCookingTimeFromCategory(current.data.cookingTimeFromCategory);
            setWeight(current.data.weightSettings.value);
            setMeasurement(current.data.weightSettings.measurement);
            setProteins(current.data.caloriesSettings.proteins);
            setCalories(current.data.caloriesSettings.calories);
            setFats(current.data.caloriesSettings.fats);
            setCarbohydrates(current.data.caloriesSettings.carbohydrates);
            menuStore.itemWorkingSchedule = current.data.workingSchedule;
            menuStore.itemCookingTime = current.data.itemCookingTime;
            menuStore.currentMenuItem = current;
            setArCodeLink(current.data.arCodeLink);
            setArCodeImage(current.data.arCodeImage);
            setSupplierLogoUrl(current.data.supplierLogoUrl);


            if (current && !cookingTimeFromCategory && current.data.itemCookingTime.fromTime) {
                setIndividualCookingTime(true)
            } else setIndividualCookingTime(false);

            const newBadge = current.data.badges[BadgeType.new];
            setNewBadgeChecked(newBadge?.isEnabled || false);

            const spicyBadge = current.data.badges[BadgeType.spicy];
            setSpicyBadgeChecked(spicyBadge?.isEnabled || false);

            const verySpiceBadge = current.data.badges[BadgeType.verySpicy];
            setVerySpicyBadgeChecked(verySpiceBadge?.isEnabled || false);

            const vegetarianBadge = current.data.badges[BadgeType.vegetarian];
            setVegetarianBadgeChecked(vegetarianBadge?.isEnabled || false);

            const hitBadge = current.data.badges[BadgeType.hit];
            setHitBadgeChecked(hitBadge?.isEnabled || false);


        } else {
            setPrice(0);
            setPriceToShow("");
            setOldPrice(0);
            setOldPriceToShow("");
            setSortOrder(0);
            setPhotos([]);
            setIsUploadInProgress(false);
            setCurrentFile(undefined);
            setModifiersSets([]);
            setCategory(null);
            setIsInStopList(false);
            setIsScheduleOpen(false);
            setCookingTimeFromCategory(false);
            setIndividualCookingTime(false);
            setMedia([]);
            setWeight(null);
            setMeasurement(null);
            setFats(null);
            setProteins(null);
            setCarbohydrates(null);
            setCalories(null);
            setArCodeLink(null);
            setArCodeImage(null);
            setSupplierLogoUrl(null);
        }

    }, [current]);



    useEffect(() => {
        externalItemsMethods.setQuery("");
    }, [externalId])


    if (!menuStore.currentMenu) return null;
    if (menuStore.currentMenu.menuCategories.length === 0) return null;
    if (menuStore.selectedCategory === undefined) return null;
    if (!current) return;
    const parentCategory = menuStore.getCategoryById(categoryId);


    const setPriceWrapper = (value: string) => {
        if(currencyFormatter.toFloat(value) < 0) return;
        setPrice(currencyFormatter.toSend(currencyFormatter.toFloat(value)));
        setPriceToShow(currencyFormatter.toStringFloat(value));
    };

    const setOldPriceWrapper = (value: string) => {
        if(currencyFormatter.toFloat(value) < 0) return;
        setOldPrice(currencyFormatter.toSend(currencyFormatter.toFloat(value)));
        setOldPriceToShow(currencyFormatter.toStringFloat(value));
    }

    let cookingTime;
    const getCookingTime = () => {
        if (individualCookingTime) {
            return cookingTime = menuStore.itemCookingTime
        } else return cookingTime = {fromTime: null, toTime: null}
    }

    const handleSubmit = async () => {
        if (externalId !== current.externalId) {
            await menuStore.updateExternalId(current.id, externalId);
        }
        getCookingTime();
        const res = await menuStore.updateMenuItem(current.id, {
            badges: {
                ...current.data.badges,
                [BadgeType.new]: {
                    isEnabled: newBadgeChecked,
                    type: BadgeType.new
                },
                [BadgeType.spicy]: {
                    isEnabled: spicyBadgeChecked,
                    type: BadgeType.spicy
                },
                [BadgeType.vegetarian]: {
                    isEnabled: vegetarianBadgeChecked,
                    type: BadgeType.vegetarian
                },
                [BadgeType.verySpicy]: {
                    isEnabled: verySpicyBadgeChecked,
                    type: BadgeType.verySpicy
                },
                [BadgeType.hit]: {
                    isEnabled: hitBadgeChecked,
                    type: BadgeType.hit
                },
            },
            name: menuStore.currentMenuItem.data.name,
            description: menuStore.currentMenuItem.data.description,
            sortOrder,
            isInStopList: isInStopList,
            menuCategoryId: category,
            menuItemModifierSets: modifiersSets,
            participatesInPromotions: true,
            photosUrls: photos,
            sellPrice: {
                price: price,
                currencyId: currencyId
            },
            oldPrice: {
                price: oldPrice,
                currencyId: currencyId
            },
            productId: undefined,
            inputProductAmountNetto: null,
            outputProductAmountNetto: null,
            manufactureId: null,
            stopListSettings: null,
            workingSchedule: {
                ...menuStore.itemWorkingSchedule,
                isEnabled: isScheduleOpen
            },
            cookingTimeFromCategory: cookingTimeFromCategory,
            itemCookingTime: cookingTime,
            media: media,
            caloriesSettings: {
                calories: calories,
                carbohydrates: carbohydrates,
                fats: fats,
                proteins: proteins
            },
            weightSettings: {
                measurement: measurement,
                value: weight
            },
            arCodeLink: (arCodeLink != null && arCodeLink.trim() != "") ? arCodeLink.trim() : null,
            arCodeImage: (arCodeImage != null && arCodeImage.trim() != "") ? arCodeImage.trim() : null,
            supplierLogoUrl: (supplierLogoUrl != null && supplierLogoUrl.trim() != "") ? supplierLogoUrl.trim() : null,
        });
        menuStore.resetItemSchedule();
        menuStore.resetItemCookingTime()

        if (res.err) {
            generalStore.showSnackbar({
                title: t("general:error"),
                description: t("menu:menuEditor.failedSavePosition"),
                type: SnackbarType.error
            })
        } else {
            generalStore.showSnackbar({
                title: t("menu:menuEditor.menuPositionUpdated"),
                type: SnackbarType.success
            })
        }
        history.push(`/menus/regular/${current.menuId}/view`)
    };

    const closeAddModifierSetForm = () => {
        setIsAddModifersSetFormVisible(false);
    };
    const submitAddModifiersSetForm = (modifierSetId: number) => {
        const newModifiers = [
            ...modifiersSets,
            {
                menuItemModifierSetId: modifierSetId,
                sortOrder: 1
            }
        ];
        setModifiersSets(newModifiers);
        closeAddModifierSetForm();
    };

    const getImageLink = (mediaItem: MediaItems) => {
        if (mediaItem.previewHighRes && mediaItem.previewHighRes != "") {
            return mediaItem.previewHighRes
        }

        return mediaItem.source
    }

    const removeImage = (position: number) => {
        const newMedia = [...media]

        newMedia.splice(position, 1)
        setMedia(newMedia)
    }



    const openDeleteForm = (current?: MenuItemType) => {
        menuStore.forms.showPopupForm(MenuFormType.deleteMenuItem, current);
    }

    const uploadAllImage = async (file: File) => {
        setIsUploadInProgress(true);
        const newMediaLinks = {...defaultMediaItems}

        try {
            setPhotos([]);
            const res = await uploadFile(file, MediaType.all);
            const { sourceDownloadUrl, sourceIdentifier, previewDownloadUrl, regularDownloadUrl } = res;
            setPhotos([sourceDownloadUrl]);
            newMediaLinks.sourceId = sourceIdentifier;
            newMediaLinks.source = sourceDownloadUrl;
            newMediaLinks.preview = previewDownloadUrl;
            newMediaLinks.previewHighRes = previewDownloadUrl;
            newMediaLinks.regular = regularDownloadUrl;
            newMediaLinks.regularHighRes = regularDownloadUrl;
        } catch (e) {
            generalStore.showSnackbar({
                title: t("general:error"),
                description: t("menu:menuEditor.failedLoadIMG"),
                type: SnackbarType.error
            })
        } finally {
            let arr = media;
            arr.push(newMediaLinks)
            setMedia(arr);
            setIsUploadInProgress(false);
        }
        return;
    }

    const uploadSupplierLogo = async (file: File) => {
        setIsUploadInProgress(true);

        try {
            setPhotos([]);
            const res = await uploadFile(file, MediaType.source);
            const { sourceIdentifier, downloadUrl } = res;
            setSupplierLogoUrl(downloadUrl)
        } catch (e) {
            generalStore.showSnackbar({
                title: t("general:error"),
                description: t("menu:menuEditor.failedLoadIMG"),
                type: SnackbarType.error
            })
        } finally {
            setIsUploadInProgress(false);
        }
        return;
    }

    const customizeImage = async (file: File) => {
        try {
            setMediaSubtypeUploadInProgress(true);
            if (!media[currentMediaIndex]?.source) return;
            const currentMediaLinks = media[currentMediaIndex]
            setFileName('');
            const res = await uploadFile(file, mediaType, currentMediaLinks.sourceId);
            const { downloadUrl, highResDownloadUrl } = res;
            if (mediaType === MediaType.preview) {
                currentMediaLinks.preview = highResDownloadUrl;
                currentMediaLinks.previewHighRes = highResDownloadUrl;
                setFileName(`${currentMediaLinks.sourceId + '_preview.jpeg'}`)
                let arr = media;
                arr[currentMediaIndex] = currentMediaLinks;
                setMedia(arr);

            }
            if (mediaType === MediaType.regular) {
                currentMediaLinks.regular = highResDownloadUrl;
                currentMediaLinks.regularHighRes = highResDownloadUrl;
                setFileName(`${currentMediaLinks.sourceId + '_regular.jpeg'}`)
                let arr = media;
                arr[currentMediaIndex] = currentMediaLinks;
                setMedia(arr);
            }
        } catch (e) {
            generalStore.showSnackbar({
                title: t("general:error"),
                description: t("menu:menuEditor.failedLoadIMG"),
                type: SnackbarType.error
            })
        } finally {
            setMediaSubtypeUploadInProgress(false);
        }
        return;
    };

    const onDrop = async (files: File[]) => {
        setCurrentFile(files[0]);
        await uploadAllImage(files[0]);
    };

    const onDropSupplierLogo = async (files: File[]) => {
        setCurrentFile(files[0])
        await uploadSupplierLogo(files[0])
    }

    const moveMediaItem = (currentPosition: number, direction: string) => {
        let newMedia = [...media]

        let newPosition = currentPosition
        if (direction == 'up') {
            newPosition -= 1
        } else {
            newPosition += 1
        }

        const elemToMove = newMedia[currentPosition]
        const elemToSubstitute = newMedia[newPosition]

        newMedia[currentPosition] = elemToSubstitute
        newMedia[newPosition] = elemToMove

        setMedia(newMedia)
    }

    return (
        <FadeInOutVertical show={true}>
            <div style={{maxWidth: 800}}>
                {history.length > 1 && <BackButton/>}
                <Typography variant={"h4"} mb={3}>
                    {t("menu:menuEditor.commonInformation")}
                </Typography>
                <Paper p={5}>
                    <div>

                        <LocalizedInput
                            label={t("general:name")}
                            value={current.data.name}
                            setNewValue={menuStore.setMenuItemName.bind(menuStore)}
                        />

                        <LocalizedInput
                            label={t("general:description")}
                            value={current.data.description}
                            setNewValue={menuStore.setMenuItemDescription.bind(menuStore)}
                            numberOfLines={5}
                        />

                        <FormControl fullWidth variant="outlined" mt={5}>
                            <InputLabel htmlFor="menuCategorySelect">{t("menu:menuEditor.category")}</InputLabel>
                            <Select
                                //disabled={hasIIkoIntegration}
                                inputProps={{
                                    id: "menuCategorySelect"
                                }}
                                value={category || categoryId}
                                onChange={changeEventHandlerDecorator(setCategory)}
                                input={<OutlinedInput
                                    labelWidth={80}
                                />}
                            >
                                {
                                    menuStore.currentMenu.menuCategories.map((item) => {
                                        return <MenuItem value={item.id} key={item.id}>
                                            {item.data.name[locale]}
                                        </MenuItem>
                                    })
                                }
                            </Select>
                        </FormControl>

                        {
                            hasIIkoIntegration && <FormControl fullWidth mt={5} variant="outlined">
                                <InputLabel>{t("menu:menuEditor.externalId")}</InputLabel>

                                <Select
                                    input={<OutlinedInput
                                        labelWidth={240}
                                    />}
                                    onChange={changeEventHandlerDecorator(setExternalId)}
                                    variant="outlined"
                                    value={externalId || "default"}
                                >
                                    <MenuItem value="default">{t("menu:menuEditor.notSelected")}</MenuItem>
                                    {externalItemsMethods.items.map(item => {
                                        return <MenuItem
                                            value={item.id}>{localize(item.title)} - {currencyFormatter.toShowFormatted(item.price.price)}</MenuItem>
                                    })}
                                </Select>
                            </FormControl>
                        }
                        <Typography variant={"h6"} mt={5} mb={2}>
                            {t("menu:menuEditor.positionPhoto")}
                        </Typography>
                        <div className={style.imageBlockContent}>
                            {
                                media.map((mediaItem, index) => {
                                    return !isMediaSubtypeUploadInProgress || index != currentMediaIndex ? (
                                        <Box css={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 5 }}>
                                            <Box css={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <Button color={'secondary'} onClick={() => moveMediaItem(index, 'up')} disabled={index == 0}>
                                                    <ArrowUp/>
                                                </Button>
                                                <Button color={'secondary'} onClick={() => moveMediaItem(index, 'down')} disabled={index == (media.length - 1)}>
                                                    <ArrowDown/>
                                                </Button>
                                            </Box>
                                            <Box css={{marginLeft: 15}} key="cmif_4">
                                                <img src={`${getImageLink(mediaItem)}?${Math.random().toString(36)}`}
                                                     // className={style.previewImage}
                                                     style={{
                                                         width: '150px',
                                                         height: '100px',
                                                         objectFit: 'cover',
                                                         borderRadius: '10px'
                                                     }}
                                                     alt=""
                                                     key={mediaItem.source}
                                                />
                                            </Box>
                                            <Box css={{display: 'flex', flexDirection: 'column'}}>
                                                <Button color={'secondary'} style={{marginLeft: 15}}
                                                    onClick={async () => {
                                                        setMediaType(MediaType.preview)
                                                        setCurrentMediaIndex(index)
                                                        await getFile(mediaItem.source)
                                                        setIsImagePreviewCropperVisible(true)
                                                    }}
                                                >
                                                    <SettingsIcon size={15}/>
                                                    <span
                                                        style={{ display: "inline-block", minWidth: 5 }}
                                                    />
                                                    Превью
                                                </Button>
                                                <Button color={'secondary'} style={{marginLeft: 15}}
                                                    onClick={async () => {
                                                        setMediaType(MediaType.regular)
                                                        setCurrentMediaIndex(index)
                                                        await getFile(mediaItem.source)
                                                        setIsImageRegularCropperVisible(true)
                                                    }}
                                                >
                                                    <SettingsIcon size={15}/>
                                                    <span
                                                        style={{ display: "inline-block", minWidth: 5 }}
                                                    />
                                                    Карточка
                                                </Button>
                                                <Button onClick={() => removeImage(index)} style={{ color: 'red', marginLeft: 10}}>
                                                    <Remove style={{maxWidth: 20}}/>
                                                    <span
                                                        style={{ display: "inline-block", minWidth: 5 }}
                                                    />
                                                    Удалить
                                                </Button>
                                            </Box>
                                        </Box>
                                    ) : (
                                        <CircularProgress
                                            m={2}
                                            ml={20}
                                            color="secondary"
                                        />
                                    )
                                })
                            }
                            <Box css={{ marginLeft: media.length == 0 ? '0px' : '78px' }}>
                                {!isUploadInProgress && (
                                    <Dropzone onDrop={onDrop} key='1'>
                                        {({getRootProps, getInputProps}) => (
                                            <div {...getRootProps({className: styles.dropzone})}
                                                 style={{maxHeight: "100px", maxWidth: "150px", width: "100%"}}>
                                                <input {...getInputProps()} />
                                                <AddIcon size={30}/>
                                                <span>{t("general:load")}</span>
                                            </div>
                                        )}
                                    </Dropzone>
                                )}
                                {isUploadInProgress && (
                                    <CircularProgress
                                        m={2}
                                        ml={20}
                                        color="secondary"
                                    />
                                )}
                            </Box>
                        </div>
                        <Typography variant={"h6"} mt={5} mb={2}>
                            {t("menu:menuEditor.specialPositionMark")}
                        </Typography>
                        <FormControl>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={newBadgeChecked}
                                            onChange={changeCheckboxEventHandlerDecorator(setNewBadgeChecked)}
                                            value={current.data.badges.New.isEnabled}
                                        />
                                    }
                                    label={t("menu:badgeType.New")}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={spicyBadgeChecked}
                                            onChange={changeCheckboxEventHandlerDecorator(setSpicyBadgeChecked)}
                                            value={current.data.badges.Spicy.isEnabled}
                                        />
                                    }
                                    label={t("menu:badgeType.Spicy")}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={verySpicyBadgeChecked}
                                            onChange={changeCheckboxEventHandlerDecorator(setVerySpicyBadgeChecked)}
                                            value={current.data.badges.VerySpicy.isEnabled}
                                        />
                                    }
                                    label={t("menu:badgeType.VerySpicy")}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={vegetarianBadgeChecked}
                                            onChange={changeCheckboxEventHandlerDecorator(setVegetarianBadgeChecked)}
                                            value={current.data.badges.Vegetarian.isEnabled}
                                        />
                                    }
                                    label={t("menu:badgeType.Vegetarian")}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={hitBadgeChecked}
                                            onChange={changeCheckboxEventHandlerDecorator(setHitBadgeChecked)}
                                            value={current.data.badges.Hit.isEnabled}
                                        />
                                    }
                                    label={t("menu:badgeType.Hit")}
                                />
                            </FormGroup>
                        </FormControl>
                    </div>
                </Paper>

                <FlexRowSpaceBetween style={{maxWidth: 800, marginTop: 80}}>
                    <Typography variant={"h4"}>
                      {t("menu:weightKkal")}
                    </Typography>
                </FlexRowSpaceBetween>
                <Paper p={5} mt={1}>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell>
                                    {t("menu:volume")}
                                </TableCell>
                                <TableCell align="right">
                                    <FormControl my={0}>
                                        <TextField
                                            inputProps={{min: 1, style: {textAlign: 'right', width: 100}}}
                                            onChange={changeEventHandlerDecorator(setWeight)}
                                            value={weight}
                                        />
                                    </FormControl>
                                </TableCell>
                                <TableCell>
                                    <FormControl fullWidth variant="outlined">
                                        <Select
                                            value={measurement}
                                            onChange={changeEventHandlerDecorator(setMeasurement)}
                                            input={<OutlinedInput
                                                labelWidth={50}
                                            />}
                                        >
                                            {
                                                measurementVariants.map(variant => {
                                                    return (
                                                        <MenuItem value={variant} key={variant}>
                                                            {variant}
                                                        </MenuItem>
                                                    )})
                                            }
                                        </Select>
                                    </FormControl>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    {t("menu:kkal")}
                                </TableCell>
                                <TableCell align="right">
                                    <FormControl my={0}>
                                        <TextField
                                            inputProps={{min: 1, style: {textAlign: 'right', width: 100}}}
                                            onChange={changeEventHandlerDecorator(setCalories)}
                                            value={calories}
                                        />
                                    </FormControl>
                                </TableCell>
                                <TableCell>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    {t("menu:protein")}
                                </TableCell>
                                <TableCell align="right">
                                    <FormControl my={0}>
                                        <TextField
                                            inputProps={{min: 1, style: {textAlign: 'right', width: 100}}}
                                            onChange={changeEventHandlerDecorator(setProteins)}
                                            value={proteins}
                                        />
                                    </FormControl>
                                </TableCell>
                                <TableCell>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    {t("menu:fat")}
                                </TableCell>
                                <TableCell align="right">
                                    <FormControl my={0}>
                                        <TextField
                                            inputProps={{min: 1, style: {textAlign: 'right', width: 100}}}
                                            onChange={changeEventHandlerDecorator(setFats)}
                                            value={fats}
                                        />
                                    </FormControl>
                                </TableCell>
                                <TableCell>
                                </TableCell>
                        </TableRow>
                        <TableRow>
                                <TableCell>
                                    {t("menu:carb")}
                                </TableCell>
                                <TableCell align="right">
                                    <FormControl my={0}>
                                        <TextField
                                            inputProps={{min: 1, style: {textAlign: 'right', width: 100}}}
                                            onChange={changeEventHandlerDecorator(setCarbohydrates)}
                                            value={carbohydrates}
                                        />
                                    </FormControl>
                                </TableCell>
                            <TableCell>
                            </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Paper>

                <FlexRowSpaceBetween style={{maxWidth: 800, marginTop: 80}}>
                    <Typography variant={"h4"}>
                        {t("menu:menuEditor.Sale")}
                    </Typography>
                    <FormControl>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={isInStopList}
                                    //disabled={hasIIkoIntegration}
                                    onChange={changeCheckboxEventHandlerDecorator(setIsInStopList)}
                                    value={!isInStopList}
                                />
                            }
                            label={t("menu:menuEditor.inStopList")}
                        />
                    </FormControl>
                </FlexRowSpaceBetween>


                <Paper p={5}>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell>Зачеркнутая цена (отображается рядом с основной)</TableCell>
                                <TableCell align="right">
                                    <FormControl my={0}>
                                        <TextField
                                            InputProps={{
                                                endAdornment: <InputAdornment
                                                    position="end">{generalStore.currency.currencyShortName[locale]}</InputAdornment>
                                            }}
                                            inputProps={{min: 1, style: {textAlign: 'right', width: 100}}}
                                            onChange={changeEventHandlerDecorator(setOldPriceWrapper)}
                                            value={oldPriceToShow}
                                        />
                                    </FormControl>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><b>{t("menu:menuEditor.price")}</b></TableCell>
                                <TableCell align="right">
                                    <FormControl my={0}>
                                        <TextField
                                            InputProps={{
                                                endAdornment: <InputAdornment
                                                    position="end">{generalStore.currency.currencyShortName[locale]}</InputAdornment>
                                            }}
                                            inputProps={{min: 1, style: {textAlign: 'right', width: 100}}}
                                            onChange={changeEventHandlerDecorator(setPriceWrapper)}
                                            value={priceToShow}
                                        />
                                    </FormControl>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Paper>

                <Space size={20}/>
                <Typography variant={"h4"}>
                    {t("menu:menuEditor.setItemCookingTime")}
                </Typography>
                <Paper p={5} mt={2}>
                    <FormControl>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={cookingTimeFromCategory}
                                    disabled={individualCookingTime}
                                    onChange={changeCheckboxEventHandlerDecorator(setCookingTimeFromCategory)}
                                    value={!cookingTimeFromCategory}
                                />
                            }
                            label={t("menu:menuEditor.asCategoryTime")}
                        />
                    </FormControl>
                    {(cookingTimeFromCategory && parentCategory && parentCategory.data.categoryCookingTime.fromTime) &&
                        <p>
                            <Trans i18nKey="menu:menuEditor.min" values={{
                                from: parentCategory.data.categoryCookingTime.fromTime,
                                to: parentCategory.data.categoryCookingTime.toTime
                            }}/>
                        </p>
                    }
                    {(cookingTimeFromCategory && parentCategory && !parentCategory.data.categoryCookingTime.fromTime) &&
                        <p>{t("menu:menuEditor.noCookingTime")}</p>
                    }
                    <FormControl>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={individualCookingTime}
                                    disabled={cookingTimeFromCategory}
                                    onChange={changeCheckboxEventHandlerDecorator(setIndividualCookingTime)}
                                    value={individualCookingTime}
                                />
                            }
                            label={t("menu:menuEditor.individualTime")}
                        />
                    </FormControl>
                    {individualCookingTime &&
                        <CookingTimeSelect item={menuStore.itemCookingTime}
                                           updateValue={menuStore.setItemCookingTime.bind(menuStore)}/>}
                </Paper>


                <Space size={20}/>
                <FlexRowSpaceBetween maxWidth={800}>
                    <Typography variant={"h4"}>
                        {t("menu:menuEditor.modifiers")}
                    </Typography>
                    <Hidden smDown>
                        <Button color={'primary'} onClick={() => {
                            setIsAddModifersSetFormVisible(true);
                        }} mt={-1}>
                            {t("menu:menuEditor.addSet")}
                        </Button>
                    </Hidden>
                </FlexRowSpaceBetween>
                {
                    modifiersSets.length === 0 && <Paper p={5} style={{maxWidth: 800, width: "100%"}}>
                        <Centered>
                            <div>
                                <Typography component="h4" variant="h4" align="center" gutterBottom>
                                    {t("menu:menuEditor.addModifiersSet")} <span role="img"
                                                                                 aria-label='newCategory'>🍒</span>
                                </Typography>
                                <Typography component="h4" variant="body2" align="center" gutterBottom>
                                    {t("menu:menuEditor.addVarietiesOfDish")} <br/>
                                    {t("menu:menuEditor.addAdditionalIngredients")} <br/>
                                    {t("menu:menuEditor.createCombo")}
                                </Typography>
                                <div style={{display: "flex", justifyContent: "center", marginTop: 20}}>
                                    <Button variant="contained"
                                            color="primary"
                                            onClick={() => setIsAddModifersSetFormVisible(true)}
                                    >
                                        <AddIcon/>
                                        {t("menu:menuEditor.addModifiersToPosition")}
                                    </Button>
                                </div>
                            </div>
                        </Centered>

                    </Paper>
                }

                {
                    modifiersSets.map((item, index) => {
                        return <Paper p={5} mb={5} mt={2} style={{maxWidth: 800, width: "100%"}}>
                            <EditModifiersSetInline
                                key={`${item.menuItemModifierSetId}_${index}`}
                                id={item.menuItemModifierSetId}
                                remove={getRemoveModifiersSet(index)}
                            />
                        </Paper>
                    })
                }
                {
                    modifiersSets.length > 0 && <Hidden mdUp>
                        <Button color={'primary'}
                                onClick={() => {
                                    setIsAddModifersSetFormVisible(true);
                                }}
                                mt={-1}
                                fullWidth
                                variant={'contained'}
                        >
                            {t("menu:menuEditor.addSet")}

                        </Button>
                    </Hidden>
                }


                <FlexRowSpaceBetween style={{maxWidth: 800, marginTop: 80}}>
                    <Typography variant={"h4"}>
                        {t("menu:menuItemSchedule")}
                    </Typography>
                    <FormControl>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={isScheduleOpen}
                                    onChange={changeCheckboxEventHandlerDecorator(setIsScheduleOpen)}
                                    value={isScheduleOpen}
                                />
                            }
                            label={t("menu:itemSchedule")}
                        />
                    </FormControl>
                </FlexRowSpaceBetween>
                {isScheduleOpen &&
                    <MenuItemSchedule/>}

                <Space size={20}/>
                <Typography variant={"h4"} mb={3}>
                    {"AR Код для позиции"}
                </Typography>
                <Paper p={5}>
                    <FormControl my={0}>
                        <TextField
                            inputProps={{min: 1, style: {textAlign: 'left', width: 300}}}
                            onChange={changeEventHandlerDecorator(setArCodeLink)}
                            value={arCodeLink}
                            label={"Ссылка на 3D модель"}
                            variant={"outlined"}
                        />
                    </FormControl>
                </Paper>

                <Space size={20}/>
                <Typography variant={"h4"} mb={3}>
                    {"Логотип поставщика"}
                </Typography>
                <Paper p={5}>
                    <FormControl my={0}>
                        <Typography variant={'subtitle1'} mb={3}>
                            Логотип не должен превышать 100x100 по ширине или высоте
                        </Typography>
                        {!isUploadInProgress && !supplierLogoUrl && (
                            <Dropzone onDrop={onDropSupplierLogo} key='1'>
                                {({getRootProps, getInputProps}) => (
                                    <div {...getRootProps({className: styles.dropzone})}
                                         style={{maxHeight: "150px", maxWidth: "150px", width: "100%"}}>
                                        <input {...getInputProps()} />
                                        <AddIcon size={30}/>
                                        <span>{t("general:load")}</span>
                                    </div>
                                )}
                            </Dropzone>
                        )}
                        {!isUploadInProgress && supplierLogoUrl && (
                            <Box css={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <Box key="cmif_4">
                                    <img src={`${supplierLogoUrl}`}
                                         style={{
                                             width: '150px',
                                             height: '150px',
                                             objectFit: 'cover',
                                             borderRadius: '10px'
                                         }}
                                         alt=""
                                         key={supplierLogoUrl}
                                    />
                                </Box>
                                <Box css={{display: 'flex'}}>
                                    <Button onClick={() => setSupplierLogoUrl(null)} style={{ color: 'red', marginLeft: 10}}>
                                        <Remove/>
                                    </Button>
                                </Box>
                            </Box>
                        )}
                        {isUploadInProgress && (
                            <CircularProgress
                                m={2}
                                ml={20}
                                color="secondary"
                            />
                        )}
                    </FormControl>
                </Paper>


                <DeleteMenuItemForm/>


                <Hidden smDown>
                    <FlexRowSpaceBetween style={{marginTop: 90}}>
                        <div>
                            <Button
                                color="default"
                                mr={5}
                                //disabled={hasIIkoIntegration}
                                onClick={(e: React.MouseEvent) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    openDeleteForm(current);
                                }}
                            >
                                <RemoveIcon color="error"/>
                                {t("menu:menuEditor.deleteCard")}
                            </Button>
                        </div>
                        <div>
                            <Button
                                color="secondary"
                                mr={5}
                                onClick={() => {
                                    history.goBack()
                                }}
                            >
                                {t("general:back")}
                            </Button>
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={handleSubmit}
                            >
                                {t("general:save")}
                            </Button>
                        </div>
                    </FlexRowSpaceBetween>
                </Hidden>
                <Hidden mdUp>
                    <Button
                        mt={5}
                        fullWidth
                        variant='outlined'
                        color="secondary"
                        onClick={() => {
                            history.goBack()
                        }}
                    >
                        {t("general:back")}
                    </Button>

                    <Button
                        mt={2}
                        fullWidth
                        color="primary"
                        variant="contained"
                        onClick={handleSubmit}
                    >
                        {t("general:save")}
                    </Button>
                    <Button
                        mt={2}
                        fullWidth
                        variant='outlined'
                        color="secondary"
                        //disabled={hasIIkoIntegration}
                        onClick={(e: React.MouseEvent) => {
                            e.preventDefault();
                            e.stopPropagation();
                            openDeleteForm(current);
                        }}
                    >
                        <RemoveIcon color="error"/>
                        {t("menu:menuEditor.deleteCard")}
                    </Button>
                </Hidden>

                <ImageCropperForm
                    open={isImagePreviewCropperVisible}
                    close={() => {
                        setIsImagePreviewCropperVisible(false);
                    }}
                    image={currentFile}
                    uploadImage={customizeImage}
                    aspectRation={ImageAspectRatio.rectangle_3_2}
                    name={fileName}
                />
                <ImageCropperForm
                    open={isImageRegularCropperVisible}
                    close={() => {
                        setIsImageRegularCropperVisible(false);
                    }}
                    image={currentFile}
                    uploadImage={customizeImage}
                    aspectRation={ImageAspectRatio.rectangle_3_2}
                    name={fileName}
                />
                <AddModifiersSetToMenuItemForm
                    closeForm={closeAddModifierSetForm}
                    addToSet={submitAddModifiersSetForm}
                    isOpen={isAddModifersSetFormVisible}
                />
            </div>
        </FadeInOutVertical>

    );
};

export default observer(EditMenuItemPage);
